export default __webpack_public_path__ + "static/media/ag-white.d6a12acf.svg";